import { updateSignUpState } from "../../../store/auth.tsx";
import axios from "../../../utils/axios.tsx";
import { i18n } from "@lingui/core";
import { msg } from "@lingui/core/macro";
import { appendStreamingTextResponse } from "../../../store/conversation.tsx";
import { SIGNUP_PROVIDER_STORAGE_KEY } from "../../../const.ts";

const handleSignupToken = async (
  signUpToken: string | null | undefined,
  dispatch: any,
) => {
  //  This function proceeds as follows:
  // 1. Fetch the sign-up token from local storage.
  // 2. If the sign-up token is in local storage and not already in the signup state,
  //    update the sign-up state with the token.
  // 3. Fetch the terms and conditions.
  // 4. If the terms and conditions are fetched successfully, append them to the conversation.
  // 5. Update the sign-up state with the terms and conditions hash.

  let signUpTokenFromStorage = localStorage.getItem("signUpToken");
  let providerFromStorage = localStorage.getItem(SIGNUP_PROVIDER_STORAGE_KEY);
  let setToken = !signUpToken && signUpTokenFromStorage;
  if (setToken) {
    dispatch(
      updateSignUpState({
        signUpToken: signUpTokenFromStorage,
        provider: providerFromStorage || null,
      }),
    );
    const termsResponse = await fetchTermsAndConditions();
    if (!termsResponse) {
      return dispatch(
        appendStreamingTextResponse(
          i18n._(
            msg({
              message:
                "I had some issues fetching the terms and conditions. Please raise a support issue.",
              context:
                "Message informing the user of an occurred problem while fetching the terms and conditions and urging him to raise this issue.",
            }),
          ),
          true,
        ),
      );
    }
    dispatch(
      appendStreamingTextResponse(
        i18n._(
          msg({
            message: `Great, thanks! Now I need to collect some additional information to complete your account setup. Please enter your company name:`,
            context:
              "Message prompting the user to enter their company name after terms are fetched.",
          }),
        ),
        true,
      ),
    );

    dispatch(
      updateSignUpState({
        termsAndConditionsHash: termsResponse.data.agreement_hash,
      }),
    );
  }
};

const fetchTermsAndConditions = async () => {
  try {
    const termsResponse = await axios.get(
      "/v1/anonymous/terms_and_conditions/",
    );
    if (termsResponse.status !== 200) {
      return null;
    }
    return termsResponse;
  } catch (error) {
    return null;
  }
};

export default handleSignupToken;
